import { useCallback, useContext } from "react";
import { endOfMonth, endOfWeek, endOfYear, startOfMonth, startOfWeek, startOfYear, subDays } from "date-fns";
import { DateUtilsContext } from "../../core";
import { DatePickerDateValue, DatePickerValue } from "./DatePicker";

export function useConvertFromServerFunction() {
  const { convertFromServerTime } = useContext(DateUtilsContext);
  return useCallback((value?: DatePickerDateValue | null): Date | null | undefined => {
    if (value === undefined) {
      return undefined;
    } else if (value === null) {
      return null;
    } else if (value instanceof Date) {
      return value;
    }
    return convertFromServerTime(value);
  }, [ convertFromServerTime ]);
}

export function useConvertToServerFunction(options: {
  timeZone?: string
  defaultTimeValue?: {
    hour: number,
    minute: number,
    second: number,
    millisecond: number,
  }
  keepTimeValue?: boolean
}) {
  const { convertToServerTime } = useContext(DateUtilsContext);
  const { defaultTimeValue, keepTimeValue } = options;

  return useCallback((v: Date | null, previousValue?: DatePickerValue | null): DatePickerValue | null => {
    if (!v) {
      return null;
    }

    const valueOnChange = new Date(v);

    if (!keepTimeValue) {
      if (defaultTimeValue) {
        valueOnChange.setHours(defaultTimeValue?.hour);
        valueOnChange.setMinutes(defaultTimeValue?.minute);
        valueOnChange.setSeconds(defaultTimeValue?.second);
        valueOnChange.setMilliseconds(defaultTimeValue?.millisecond);
      }
    }

    debugger;
    return convertToServerTime(valueOnChange);
  }, [ convertToServerTime, defaultTimeValue, keepTimeValue ]);
}

export const getToday = (): [ Date | null, Date | null ] => [ new Date(), new Date() ];

export const getYesterday = (): [ Date | null, Date | null ] => {
  const yesterday = subDays(new Date(), 1);
  return [ yesterday, yesterday ];
};

export const getLastWeek = (): [ Date | null, Date | null ] => {
  const today = new Date();
  return [ startOfWeek(subDays(today, 7)), endOfWeek(subDays(today, 7)) ];
};

export const getThisWeek = (): [ Date | null, Date | null ] => {
  const today = new Date();
  return [ startOfWeek(today), endOfWeek(today) ];
};

export const getThisMonth = (): [ Date | null, Date | null ] => {
  const today = new Date();
  return [ startOfMonth(today), endOfMonth(today) ];
};

export const getLastMonth = (): [ Date | null, Date | null ] => {
  const today = new Date();
  return [ startOfMonth(subDays(startOfMonth(today), 1)), endOfMonth(subDays(startOfMonth(today), 1)) ];
};

export const getThisYear = (): [ Date | null, Date | null ] => {
  const today = new Date();
  return [ startOfYear(today), endOfYear(today) ];
};

export const getLastYear = (): [ Date | null, Date | null ] => {
  const today = new Date();
  return [ startOfYear(subDays(startOfYear(today), 1)), endOfYear(subDays(startOfYear(today), 1)) ];
};

export const getAllTime = (): [ Date | null, Date | null ] => {
  const today = new Date();
  return [ new Date(2000, 0, 1), today ];
};

